export default __webpack_public_path__ + "static/media/hidden_pw.08171ebc.svg";